'use client';
import React from 'react';
import LoginBox from '../../Molecules/LoginBox';
import DynamicBox from '../DynamicBox/DynamicBox';
import Image from 'next/image'

interface LoginProps {
  apiUrl: string;
}

const LoginContainer: React.FC<LoginProps> = ({ apiUrl }) => {
  return (
    <DynamicBox
      title="Hello User! Welcome to Dekarb"
      subtitle="Carbon Footprint Calculator"
      text=""
    >
      <div className='-mt-3'>
        <Image
          src={'/line-pattern-design.svg'}
          alt='line-pattern-design'
          width={90}
          height={4}
        />
        </div>
      <LoginBox apiUrl={apiUrl} />
    </DynamicBox>
  );
};

export default LoginContainer;
